import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import * as bankAccountActions from '../../../redux/actions/bankAccount.action'
import { RootReducers } from '../../../redux/reducers'
import { useDispatch, useSelector } from 'react-redux'
import PaymentComponent from './paymentComponent'
import { BankAccountModelView } from '../../../models/bankAccount'
import BankAccountComponent from './bankAccountComponent'
import { findPayInBankTypesByAccountNo, getBankAccountData } from './bankAccountData'
import { LoadingOverlay } from '../../loadingOverlay'

export interface IPayInBankProps {
  name?: string
  value?: string
  branchCode: string
  paymentMode: string
  defaultPayInBankType?: string
  defaultBankCode?: string
  defaultAccount?: string
  onSelect: (documentDetail: BankAccountModelView) => void
  isRequireBank?: boolean
  isRequireAccountNo?: boolean
  disabled?: boolean
}

export const PayInBank: React.VFC<IPayInBankProps> = ({
  name,
  paymentMode,
  branchCode,
  defaultPayInBankType = '',
  defaultBankCode = '',
  defaultAccount = '',
  onSelect,
  isRequireBank = false,
  isRequireAccountNo = false,
  disabled
}) => {
  const dispatch = useDispatch()
  const bankAccountData = useSelector((state: RootReducers) => state.bankAccountReducer)
  const [selectedValue, setSelectedValue] = useState<BankAccountModelView>({
    target: { value: '', name: '' },
    payInToBank: ''
  })

  useEffect(() => {
    dispatch(bankAccountActions.getBankAccount(paymentMode, branchCode))
  }, [])

  const [selectedBank, setSelectedBank] = useState(null)
  const [selectedAccount, setSelectedAccount] = useState(null)

  const handleOnPayInBankTypeSelect = (e: any) => {
    onSelect({ target: { name: 'payInToBank', value: e }, payInToBank: '' })
  }
  const handleOnBankCodeSelect = (e: any) => {
    onSelect({ target: { name: 'bankCode', value: e }, payInToBank: '' })
  }
  const handleOnAccountSelect = (e: any) => {
    onSelect({ target: { name: 'accountNo', value: e }, payInToBank: findPayInBankTypeSelect(e) })
  }

  const findPayInBankTypeSelect = (e: any) => {
    if (bankAccountData && bankAccountData.data) {
      const value = findPayInBankTypesByAccountNo(e, bankAccountData.data)
      //onSelect({ target: { name: 'payInToBank', value: value } })
      return value
    }
    return ''
  }

  const onToFindPayInBankTypeSelect = (e: any) => {
    if (bankAccountData && bankAccountData.data) {
      const value = findPayInBankTypesByAccountNo(e, bankAccountData.data)
      onSelect({ target: { name: 'payInToBank', value: value }, payInToBank: '' })
    }
  }

  return (
    <div>
      {bankAccountData.isFetching && <LoadingOverlay />}

      {/* <PaymentComponent
        data={bankAccountData.data}
        onPayInBankTypeSelect={handleOnPayInBankTypeSelect}
        onBankCodeSelect={handleOnBankCodeSelect}
        onAccountSelect={handleOnAccountSelect}
        formErrors={{}}
        defaultPayInBankType={defaultPayInBankType}
        defaultBankCode={defaultBankCode}
        defaultAccount={defaultAccount}
      ></PaymentComponent> */}
      {bankAccountData && bankAccountData.data && (
        <BankAccountComponent
          banks={getBankAccountData(bankAccountData.data)}
          paymentMode={''}
          branchCode={''}
          disabled={disabled}
          onToFindPayInBankTypeSelect={onToFindPayInBankTypeSelect}
          onBankCodeSelect={handleOnBankCodeSelect}
          onAccountSelect={handleOnAccountSelect}
          defaultBankCode={defaultBankCode}
          defaultAccount={defaultAccount}
          isRequireBank={isRequireBank}
          isRequireAccountNo={isRequireAccountNo}
        ></BankAccountComponent>
      )}
    </div>
  )
}
